import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal, NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { Observable, debounceTime, distinctUntilChanged, filter, map, switchMap, takeUntil } from 'rxjs';
import { PropertyFilter } from '../../Models/OtherClasses';
import { BaseBusyableComponent } from '../../Services/BaseBusyableComponent';
import { ConfigService } from "../../Services/ConfigService";
import { CustomerAccountService } from "../../Services/Custom/ServiceCustomerAccount";
import { CustomerPropertyItemEditComponent } from '../CustomerAccount/PropertyItemComponentEdit';
import { PropertyItemMoveBulkComponent } from '../PopUps/PropertyItemMoveBulkComponent';
import { PropertyItemBulkComponent } from '../PopUps/PropertyItemBulkComponent';
import { PropertyItemBulkActionEnum } from '../../Models/Interfaces/PropertyItemBulkActionEnum';
import { PersonRoleEnum } from '../../Models/OtherClasses';
import { SearchService } from '../../Services/Custom/ServiceSearch';
import { PropertyItemService } from '../../Services/Custom/ServicePropertyItem';

@Component({
	selector: 'PropertyItemGrid',
	templateUrl: 'PropertyItemGrid.html',
})
export class PropertyItemGridComponent extends BaseBusyableComponent {

	@Input()
	filterObj = new PropertyFilter();

	@Output()
	itemsFiltered = new EventEmitter<TooBig4Car.Logic.PropertyItem[]>();

	@Output()
	newClicked = new EventEmitter<any>();

	@Output()
	backEndSearch = new EventEmitter<PropertyFilter>();

	@Output()
	onExport = new EventEmitter<PropertyFilter>();

	searchBackEnd() {
		this.backEndSearch.emit(this.filterObj);
	}

	loadAll() {
		this.filterObj.type = '';
		this.filterObj.sidemark = '';
		this.filterObj.description = '';
		this.filterObj.needsInspection = null;
		this.filterObj.needsRepair = null;
		this.filterObj.dateStart = null;
		this.filterObj.dateFinish = null;
		this.filterObj.includeDelivered = false;
		this.searchBackEnd();
	}

	exportBackEnd() {
		this.onExport.emit(this.filterObj);
	}
	newBtnClicked() {
		this.newClicked.emit({});
	}

	bulkMove() {
		if (this.allowBulkMove()) {
			var thisHolder = this;
			var moveObjs = this.filteredItems.filter(a => a.IsSelected && a.APICanIMoveThis);
			var idsToMove = moveObjs.map(a => {
				var obj = {
					ID: a.PropertyItemID,
					SearchName : (a.CustomerAccountName + ' ' + a.Description),
					TypeObject : "PropertyItem"
				} as TooBig4Car.Logic.SearchVM;
				return obj;
			});

			var modal = thisHolder.mymodalService.open(PropertyItemMoveBulkComponent);
			modal.componentInstance.myItem = {
				Items: idsToMove
			} as TooBig4Car.Logic.PropertyItemMoveBulkVM
			modal.result.then(refresh => {
				if (refresh) {
					thisHolder.refreshData.emit();
				}
			}, (reason) => {

			});
		}
	}
	allowBulkMove(): boolean {
		return this.allowMove;
	}

	get showCheckboxes(): boolean {
		return this.allowMove || this.employee || this.anyCustomerEditable;
	}

	get anySelected(): boolean {
		return this.filteredItems.some(a => a.IsSelected && (a.APIAnyBulkActionOk || a.APICanIEditCustomerFields));
	}

	get selectableItems(): TooBig4Car.Logic.PropertyItem[] {
		return this.filteredItems.filter(a => a.APICanIMoveThis || a.APIAnyBulkActionOk || a.APICanIEditCustomerFields);
	}

	get allSelected(): boolean {
		var col = this.selectableItems;
		return col.length > 0 && col.every(a => a.IsSelected);
	}

	selectAll() {
		var isSel = !this.allSelected;
		this.selectableItems.forEach(item => {
			item.IsSelected = isSel;
		});
	}

	get bulkActions(): any[] {
		return PropertyItemBulkActionEnum.getChoices().filter(a => {
			switch (a.Value) {
				case PropertyItemBulkActionEnum.MarkOutOfStorage:
					return this.employee && (this.configData.IsUserInRole(PersonRoleEnum.ADMIN) || this.configData.IsUserInRole(PersonRoleEnum.TREASURY));
				case PropertyItemBulkActionEnum.Delete:
					return this.employee && this.configData.IsUserInRole(PersonRoleEnum.ADMIN);
				case PropertyItemBulkActionEnum.ChangeSidemark:
				case PropertyItemBulkActionEnum.ChangeDestinationRoom:
					return true;
				default:
					return this.employee;
			}
		});
	}

	doBulkAction(action: any) {
		var items = this.filteredItems.filter(a => a.IsSelected && (a.APIAnyBulkActionOk || a.APICanIEditCustomerFields));
		var bAction: TooBig4Car.Logic.PropertyItemBulkActionVM = {
			Action: action.Value,
			IDs: items.map(a => a.PropertyItemID.toString()),
			TypeStorageFeeID: this.configData.DefaultEmptyGuid
		};
		if (!bAction.IDs.length) {
			return;
		}
		var thisHolder = this;
		if (action.Value == PropertyItemBulkActionEnum.Delete) {
			thisHolder.dialogService.confirm(`Are you sure you want to delete ${bAction.IDs.length} ${bAction.IDs.length > 1 ? 'pieces' : 'piece'}?`).then(cfm => {
				if (cfm) {
					thisHolder.isSaving = true;
					thisHolder.myPropertyItemService.bulkAction(bAction)
						.pipe(takeUntil(thisHolder.obsToCloseSubject))
						.subscribe(result => {
							thisHolder.isSaving = false;
							thisHolder.bulkActionDone(result);
						},
							(error: any) => {
								thisHolder.isSaving = false;
							});
				}
			});
		} else {
			var modal = thisHolder.mymodalService.open(PropertyItemBulkComponent);
			modal.componentInstance.setItem(bAction);
			if (items.every(a => a.CustomerAccountID == items[0].CustomerAccountID)) {
				modal.componentInstance.customerAccountID = items[0].CustomerAccountID;
			}
			modal.result.then((result: any) => {
				if (result) {
					thisHolder.bulkActionDone(result);
				}
			}, (reason) => {

			});
		}
	}

	bulkActionDone(result: any) {
		this.dialogService.message(`Succeeded: ${result.Succeeded}, Failed: ${result.Failed}`, 'Results');
		if (this.showBackendSearch) {
			this.searchBackEnd();
		} else {
			this.refreshData.emit();
		}
	}

	@Input()
	showPending = false;

	@Input()
	showBackendSearch = false;

	@Input()
	showDeliveryColumn = false;

	@Input()
	showInspectionTargetDateSeparately = false;

	@Input()
	showDestinationRoom = false;

	@Input()
	showLocation = false;

	@Input()
	showDate = false;

	@Input()
	allowMove = false;

	@Input()
	showSearch: boolean = true;

	@Input()
	showSpecifics: boolean = true;

	@Input()
	showCustomer: boolean = true;

	@Input()
	showNewBtn: boolean = false;

	@Input()
	showDeleteBtn = false;

	deleteItem(item: TooBig4Car.Logic.PropertyItemBase) {
		if (item.APICanIDeleteThis) {
			var thisHolder = this;
			this.dialogService.confirm(this.configData.TranslateWords.AreYouSure).then(result => {
				if (result) {
					thisHolder.myPropertyItemService.deleteItem(item.PropertyItemID)
						.subscribe(() => {
							thisHolder._items.splice(thisHolder._items.indexOf(item), 1);
							this.filterItems(null);
							thisHolder.refreshData.emit();
						});
				}
			});
		}
	}

	@Input()
	typeChoices: TooBig4Car.Logic.CustomerTypeProperty[] = null;

	@Input()
	typeEdits: { [id: string]: TooBig4Car.Logic.CustomerTypeProperty } = {};

	canEditType(item: TooBig4Car.Logic.PropertyItem): boolean {
		return !!this.typeChoices && item.IsPendingItem && item.APIAnyBulkActionOk;
	}

	typeNameFor(item: TooBig4Car.Logic.PropertyItem): string {
		var edit = this.typeEdits[item.PropertyItemID.toString()];
		return edit ? edit.TypeName : item.TypeName;
	}

	propTypeInputFormatter = (value: TooBig4Car.Logic.TypePropertyItem) => value.TypeName;

	propTypeFormatter = (value: TooBig4Car.Logic.TypePropertyItem) => {
		var val = value.TypeName;
		if (value.ModelNumber) {
			val += " (" + value.ModelNumber + ")";
		}
		return val;
	};

	searchPropType = (text$: Observable<string>) =>
		text$.pipe(
			filter(term => term != '' && term.length > 1),
			map(a => a.trim().toLowerCase()),
			distinctUntilChanged(),
			map((term: string) => {
				return this.typeChoices.filter(a => {
					return a.ModelNumber.toLowerCase().indexOf(term) >= 0
						|| a.TypeName.toLowerCase().indexOf(term) >= 0
						;
				}).slice(0, 10);
			})
		);

	onSelectPropType($event: any, item: TooBig4Car.Logic.PropertyItem) {
		var typeP = $event.item as TooBig4Car.Logic.CustomerTypeProperty;
		if (typeP) {
			var id = item.PropertyItemID.toString();
			if (typeP.ParentTypePropertyItemID == item.TypeID) {
				delete this.typeEdits[id];
			} else {
				this.typeEdits[id] = typeP;
			}
		}
	}

	nextPropType($event: any, typeahead: NgbTypeahead) {
		if ($event.defaultPrevented || typeahead.isPopupOpen()) {
			return;
		}
		$event.preventDefault();
		var boxes = Array.from(document.querySelectorAll<HTMLInputElement>('input[id$="propTypeEditBox"]'));
		boxes[boxes.indexOf($event.target) + 1]?.focus();
	}

	@Output()
	refreshData = new EventEmitter<any>();

	@Output()
	inspectClicked = new EventEmitter<TooBig4Car.Logic.PropertyItem>();

	inspectBtnClicked(item: TooBig4Car.Logic.PropertyItem) {
		this.inspectClicked.emit(item);
	}

	@Input()
	showInspectBtn: boolean = false;

	@Output()
	moveClicked = new EventEmitter<TooBig4Car.Logic.PropertyItem>();

	moveBtnClicked(item: TooBig4Car.Logic.PropertyItem) {
		this.moveClicked.emit(item);
	}

	@Input()
	showMoveBtn: boolean = false;

	@Input()
	showExportBtn: boolean = false;

	@Input()
	showLoadAllBtn: boolean = false;

	constructor(
		public configData: ConfigService,
		public myCustomerAccountService: CustomerAccountService,
		public myPropertyItemService: PropertyItemService,
		public mySearchService: SearchService,
		private mymodalService: NgbModal) {
		super();

		this.sortCriteria = { sortColumn: 'TypeName, Description', sortDirection: 'asc' };
		this.employee = this.configData.isEmployee();

		this.filterEmitter.asObservable()
			.pipe(
				debounceTime(300)
			)
			.pipe(takeUntil(this.obsToCloseSubject))
			.subscribe(fobj => {
				this.innerFilterItems(fobj);
			});
	}

	employee: boolean = false;

	_items: TooBig4Car.Logic.PropertyItem[] = [];
	@Input()
	set items(val: TooBig4Car.Logic.PropertyItem[]) {
		this._items = val;
		this.innerFilterItems(this.filterObj);
	}

	get items(): TooBig4Car.Logic.PropertyItem[] {
		return this._items;
	}

	filteredItems: TooBig4Car.Logic.PropertyItem[] = [];
	anyCustomerEditable = false;

	onSort(newCriteria: TooBig4Car.Logic.SortCriteria) {
		super.onSort(newCriteria);
		this.filteredItems = this.configData.SortArray(this.filteredItems, this.sortCriteria);
	}

	filterEmitter: EventEmitter<PropertyFilter> = new EventEmitter<PropertyFilter>();

	preventClick(evt: any) {
		evt.preventDefault();
		evt.stopPropagation();
	}
	filterItems(evt: any) {
		this.filterEmitter.next(this.filterObj);
	}
	innerFilterItems(fobj: PropertyFilter) {
		if (!this.showBackendSearch) {
			var col: TooBig4Car.Logic.PropertyItem[] = [];
			if (fobj) {
				col = fobj.filterItems(this._items);
			} else {
				col = this._items;
			}
			this._items.filter(a => a.IsSelected && col.indexOf(a) < 0).forEach(a => {
				a.IsSelected = false;
			});
			this.filteredItems = this.configData.SortArray(col, this.sortCriteria);
			this.itemsFiltered.next(this.filteredItems);
		} else {
			this.filteredItems = this.configData.SortArray(this._items, this.sortCriteria);
		}
		this.anyCustomerEditable = this.filteredItems.some(a => a.APICanIEditCustomerFields);
	}
	@Input()
	public sortCriteria: TooBig4Car.Logic.SortCriteria;

	popUpEdit(item: TooBig4Car.Logic.PropertyItem) {
		var thisHolder = this;
		var modal = thisHolder.mymodalService.open(CustomerPropertyItemEditComponent);
		modal.componentInstance.loadItem(this.configData.deepClone(item));
		modal.result.then((result: TooBig4Car.Logic.PropertyItem) => {
			if (result) {
				this._items.splice(this._items.indexOf(item), 1);
				this._items.push(result);
				this.filterItems(null);
			}
		});
	}

	customerFormatter = (value: TooBig4Car.Logic.CustomerAccount) => {
		return value.CustomerName;
	}
	searchCustomer = (text$: Observable<string>) =>
		text$.pipe(
			filter(term => term != '' && term.length >= 1),
			map(a => a.trim()),
			debounceTime(400),
			distinctUntilChanged(),
			switchMap((term: string) => this.myCustomerAccountService.searchFullResults(term, false, false))
		);
	onSelectCustomer($event: any) {
		$event.preventDefault();
		var cust: TooBig4Car.Logic.CustomerAccount = $event.item;
		if (this.filterObj.customerAccountID != cust.CustomerAccountID) {
			this.filterObj.customerAccountID = cust.CustomerAccountID;
			this.filterObj.customer = cust.CustomerName;
			this.filterItems(null);
		}
	}

	sidemarkFormatter = (value: TooBig4Car.Logic.SearchResultBase) => value.SearchName;

	searchSidemark = (text$: Observable<string>) => {
		this.filterItems(null);
		return text$.pipe(
			filter(term => term != '' && term.length > 1),
			map(a => a.trim()),
			debounceTime(400),
			distinctUntilChanged(),
			switchMap((term: string) => {
				
				var obj = {
					CustomerAccountID: this.filterObj.customerAccountID,
					SearchText: term,
					Include: true
				};
				return this.mySearchService.searchSidemarks(obj);
			})
		);
	};

	onSelectSidemark($event: any, item: TooBig4Car.Logic.PropertyItem) {
		$event.preventDefault();
		this.filterObj.sidemark = $event.item.SearchName;
		this.filterItems(null);
	}
}
